import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Header = styled.h2`
  border-bottom: 1px solid #ccc;
  padding: 10px 0px;
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 1rem 0;
`;

const Container = styled.div`
  margin-bottom: 0.5rem;
`;

const Bold = styled.strong`
  margin-right: 0.4rem;
`;

export const mapStateToProps = ({
  addresses: { defaultAddressKey, [defaultAddressKey]: address } = {},
  localPickup: { dateDisplay: { shortDate: dateDisplay }, selectedTimeslot, instructions } = {},
  language: {
    'returns.step_3.local_pickup.title': title,
    'returns.step_3.local_pickup.time_label': timeLabel,
    'returns.step_3.local_pickup.address_label': addressLabel,
    'returns.step_3.local_pickup.instructions_label': instructionsLabel,
  },
}) => ({
  address,
  dateDisplay,
  selectedTimeslot,
  instructions,
  title,
  timeLabel,
  addressLabel,
  instructionsLabel,
});

const LocalPickupDetails = ({
  address: { street_1: street1, street_2: street2, city, state, zip },
  dateDisplay,
  selectedTimeslot,
  instructions,
  title,
  timeLabel,
  addressLabel,
  instructionsLabel,
}) => (
  <div style={{ marginTop: '-1.5rem', marginBottom: '4rem' }}>
    <div>
      <Header>{title}</Header>
    </div>
    <Container>
      <Bold>{timeLabel}</Bold>
      {`${dateDisplay} ${selectedTimeslot.label}`}
    </Container>
    <Container>
      <Bold>{addressLabel}</Bold>
      {street2
        ? `${street1}, ${street2}, ${city}, ${state} ${zip}`
        : `${street1}, ${city}, ${state} ${zip}`}
    </Container>
    {instructions && (
      <Container>
        <Bold>{instructionsLabel}</Bold>
        <span>{instructions}</span>
      </Container>
    )}
  </div>
);

LocalPickupDetails.defaultProps = {
  title: '',
  timeLabel: '',
  addressLabel: '',
  instructionsLabel: '',
};

LocalPickupDetails.propTypes = {
  address: PropTypes.shape({
    street_1: PropTypes.string,
    street_2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
  dateDisplay: PropTypes.string.isRequired,
  selectedTimeslot: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  instructions: PropTypes.string.isRequired,
  title: PropTypes.string,
  timeLabel: PropTypes.string,
  addressLabel: PropTypes.string,
  instructionsLabel: PropTypes.string,
};

export default connect(mapStateToProps)(LocalPickupDetails);
